// extracted by mini-css-extract-plugin
export default {"nav__item":"FooterNavItem_nav__item__my0xe","navlink":"FooterNavItem_navlink__XIeMP","navLinkActive":"FooterNavItem_navLinkActive__MCaMx"};